/**
 * Normalize profile picture paths from API/DB into a value suitable for useSignedImageUrl / AuthImage.
 */
export function resolveTeacherProfilePictureSource(
  teacherLike: Record<string, unknown> | null | undefined
): string | null {
  if (!teacherLike) return null

  const direct = teacherLike.profile_picture
  if (typeof direct === 'string' && direct.trim()) return direct.trim()

  const url = teacherLike.profile_picture_url ?? teacherLike.photo_url
  if (typeof url === 'string' && url.trim()) return url.trim()

  const pictures = teacherLike.profile_pictures
  if (Array.isArray(pictures) && pictures.length > 0) {
    const active =
      pictures.find((p) => p && typeof p === 'object' && (p as any).is_active !== false) ?? pictures[0]
    if (active && typeof active === 'object') {
      const row = active as Record<string, unknown>
      const filePath = row.file_path ?? row.url
      if (typeof filePath === 'string' && filePath.trim()) return filePath.trim()
      const fileName = row.file_name
      if (typeof fileName === 'string' && fileName.trim()) {
        return `/api/uploads/profile-pictures/${fileName.trim()}`
      }
    }
  }

  return null
}

/** Build same-origin URL for img src (never double-prefix /api). */
export function toProfilePictureDisplayPath(raw: string | null | undefined): string | null {
  if (!raw || typeof raw !== 'string') return null
  const trimmed = raw.trim()
  if (!trimmed) return null
  if (trimmed.startsWith('blob:') || trimmed.startsWith('data:')) return trimmed
  if (trimmed.startsWith('http://') || trimmed.startsWith('https://')) {
    try {
      const u = new URL(trimmed)
      const idx = u.pathname.indexOf('/uploads/')
      if (idx >= 0) {
        return `/api${u.pathname.slice(idx)}`
      }
      return trimmed
    } catch {
      return trimmed
    }
  }
  if (trimmed.startsWith('/api/uploads/')) return trimmed
  if (trimmed.startsWith('/uploads/')) return `/api${trimmed}`
  if (trimmed.startsWith('uploads/')) return `/api/${trimmed}`
  if (!trimmed.includes('/') && !trimmed.includes('\\')) {
    return `/api/uploads/profile-pictures/${trimmed}`
  }
  return trimmed.startsWith('/') ? `/api${trimmed}` : `/api/${trimmed.replace(/^\/+/, '')}`
}
